import { render, staticRenderFns } from "./DataUploadedModal.vue?vue&type=template&id=c8f96cb2&scoped=true"
import script from "./DataUploadedModal.vue?vue&type=script&lang=js"
export * from "./DataUploadedModal.vue?vue&type=script&lang=js"
import style0 from "./DataUploadedModal.vue?vue&type=style&index=0&id=c8f96cb2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f96cb2",
  null
  
)

export default component.exports